import axios from "axios";
import {jwtDecode} from "jwt-decode";
import {SwalAlertClass} from "core/swalClass";

const timeExpire = parseInt(process.env.REACT_APP_TIME_REFRESH);
const axiApi = axios.create();
const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

const getErrorMessage = (error) => {
    console.log("Error response data:", error.response?.data);

    //  message del backend  (no "")
    if (
        error.response &&
        error.response.data &&
        error.response.data.message !== undefined &&
        error.response.data.message.trim() !== ""
    ) {
        console.log("mensaje del backend:", error.response.data.message);
        return String(error.response.data.message);
    } else if (error.message) {
        console.log("mensaje de Axios:", error.message);
        return error.message;
    }

    return "Error desconocido";
};

async function refreshToken() {
    console.log("refreshToken()");
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await axios.post(`/api/token/refresh/`, {refresh: refreshToken});
    if (response.status === 200) {
        const {token} = response.data;
        if (token) {
            localStorage.setItem("token", token.access);
            localStorage.setItem("refreshToken", token.refresh);
        }
    } else {
        localStorage.clear();
        window.navigator.href = "/login/";
    }
}

// Interceptor de Petición (Request) - SIMPLIFICADO
axiApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        // Simplemente añade el token si existe. Nada de refrescos aquí.
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

axiApi.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                // Si ya se está refrescando, aparcamos la petición
                return new Promise(function (resolve, reject) {
                    failedQueue.push({resolve, reject});
                }).then((token) => {
                    originalRequest.headers["Authorization"] = "Bearer " + token;
                    return axios(originalRequest);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const refreshToken = localStorage.getItem("refreshToken");
                if (!refreshToken) throw new Error("No refresh token available");

                const response = await axios.post(`/api/token/refresh/`, {
                    refresh: refreshToken,
                });

                const newAccessToken = response.data.access;
                const newRefreshToken = response.data.refresh;

                localStorage.setItem("token", newAccessToken);
                if (newRefreshToken) {
                    localStorage.setItem("refreshToken", newRefreshToken);
                }

                isRefreshing = false;
                processQueue(null, newAccessToken);

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axios(originalRequest);
            } catch (refreshError) {
                isRefreshing = false;
                processQueue(refreshError, null);
                console.error(
                    "[ApiCaller] Error CRÍTICO al refrescar el token",
                    refreshError
                );
                localStorage.clear();
                window.location.href = "/login/";
                return Promise.reject(refreshError);
            }
        }

        const statusCode = error.response?.status;

        if (statusCode === 403) {
            const errorMessage = getErrorMessage(error);
            Alert.error("Acceso denegado", errorMessage).then(() => {
                window.location.href = "/";
            });
        } else if (statusCode && parseInt(statusCode / 100) === 4) {
            return Promise.reject(error);
        } else {
            const errorMessage = getErrorMessage(error);
            if (statusCode && statusCode !== 401) {
                Alert.error(`Error ${statusCode}`, errorMessage);
            }
        }

        return Promise.reject(error);
    }
);

export {Alert};
export default axiApi;
